<template>
  <div id="communication-tab">
    <div class="section-top m-t-20">
      <div class="head-section">
        <h4 class="section-title">
          <span>{{ $t('UserKit.communication_tab.destination_managers') }}</span>
        </h4>
      </div>

      <div class="content-section m-t-15">
        <div class="row">
          <div class="col-md-5 col-lg-4">
            <communication-item :youtubeUrl="youtubeUrl"
                                :description="$t('UserKit.communication_tab.description_video')"></communication-item>
          </div>
        </div>
      </div>
    </div>

    <div class="section-bottom m-t-20">
      <div class="head-section">
        <h4 class="section-title">
          <span>{{ $t('UserKit.communication_tab.destination_candidate') }}</span>
        </h4>
      </div>

      <div class="content-section m-t-15">
        <div class="row">
          <div class="col-md-4 item-wrapper">
            <communication-item :pathImage="pathImage.thumbPoster"
                                :description="$t('UserKit.communication_tab.description_poster')"
                                :pathSee="'/static/files/affiche-permuteo.pdf'"
                                :fileName="'affiche-permuteo.pdf'"></communication-item>
          </div>
          <div class="col-md-4 item-wrapper">
            <communication-item :pathImage="pathImage.ThumbFlyer"
                                :description="$t('UserKit.communication_tab.description_flyer')"
                                :pathSee="'/static/files/flyer-permuteo.pdf'"
                                :fileName="'flyer-permuteo.pdf'"></communication-item>
          </div>
          <div class="col-md-4 select-entity">
            <p align="center">{{ $t('UserKit.communication_tab.code_entity') }}</p>
            <select-entity :entities="entityAll"
                           :labelEntity="$t('Offers.filters.entities')"
                           :entitySelector="'entity_id_in'"
                           :colLabel="'col-md-10'"
                           :colSelect="'col-md-10'"
                           :marginEntity="'m-t-5'"
                           @entity-changed="changeFilterEntity" v-if="!isSingleEntity" />
            <p class="entity-code" align="center" v-if="entityCode">
              {{ entityCode }}
            </p>
            <div v-if="qrCodeUrl" class="entity-qr-code">
              <img :src="qrCodeUrl"/>
              <button class="btn btn-link" @click="downloadQrCode">Télécharger</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import CommunicationItem from './CommunicationItem'
  import SelectEntity from '@/components/common/SelectEntity'
  import thumbPoster from '@/assets/img/pages/thumb/snapshot-affiche-permuteo.png';
  import ThumbFlyer from '@/assets/img/pages/thumb/snapshot-flyer-permuteo.png';
  import iconDownload from '@/assets/img/pages/icons/icons8-downloading-updates-60.png';
  import QRCode from 'qrcode'

  export default {
    name: "CommunicationTab",
    components: {
      CommunicationItem,
      SelectEntity
    },
    data: function() {
      return ({
        code: null,
        percentWidthLine: 0,
        pathImage: {
          thumbPoster: thumbPoster,
          ThumbFlyer: ThumbFlyer,
          iconDownload: iconDownload
        },
        youtubeUrl: 'https://www.youtube.com/embed/yb7Q3k3fsJU',
        qrCodeUrl: null
      })
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        isSingleEntity: 'auth/isSingleEntity',
      }),
      signupUrl() {
        if (!this.entityCode) return ''

        const path = this.$router.resolve({
          name: 'SignUpForm',
          params: { entityCode: this.entityCode }
        })
        return window.location.origin + path.href
      },
      entityCode() {
        var code = "";
        if (this.isSingleEntity) {
          code = this.currentUser.entities[0].entity_code;
        } else {
          code = this.code
        }
        return code;
      },
      entityAll() {
        let entities = []
        if (this.currentUser.entities) {
          entities = this.currentUser.entities
        }

        return entities
      },
    },
    methods: {
      changeFilterEntity(value) {
        this.code = value.entity_code
        this.renderQrCode()
      },
      renderQrCode() {
        if (this.entityCode) {
          QRCode.toDataURL(this.signupUrl)
            .then(url => this.qrCodeUrl = url)
            .catch(error => console.error(error))
        }
      },
      downloadQrCode() {
        if (this.qrCodeUrl){
          let link = document.createElement('a');
           link.href = this.qrCodeUrl;
           link.download = `qrcode-${this.entityCode}.png`;
           document.body.appendChild(link);
           link.click();
           setTimeout(function(){
             document.body.removeChild(link);
             window.URL.revokeObjectURL(link.href);
           }, 100);
         }
      }
    },
    mounted() {
      this.renderQrCode()
    }
  }
</script>

<style scoped lang="scss">
  $color-line: #ddd !default;

  #communication-tab {
    .section-title {
      width: 100%;
      text-align: left;
      border-bottom: 1px solid $color-line;
      line-height: 0.1em;
      margin: 30px 0 25px;
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 14px;
      span {
        background: #fff;
        padding: 0 10px 0 0;
        text-transform: uppercase;
      }
    }

    .entity-code {
      max-width: 130px;
      
      background: #E64949;
      color: white;
      font-weight: bold;
      padding: 15px 5px;
      border-radius: 5px;
      margin: 20px auto 0;
      font-size: 16px;
    }

    .entity-qr-code {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .select-entity .align-items-center.form-group {
      padding-left: 10%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userKit/CommunicationTab.vue